module.exports = __webpack_public_path__ + "static/factory-41f26fab03b39bed7276b2553899e78b.svg";